module.exports = {"141031100":"龙泉镇","141031101":"午城镇","141031102":"黄土镇","141031200":"阳头升乡","141031201":"寨子乡","141031203":"下李乡","141031204":"城南乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141031.json
// module id = 460
// module chunks = 0